import React, { useEffect, useState } from "react";
import Input from "components/ui/Input/Input";

const SmartSelector = React.forwardRef((props, ref) => {
    const { options, onChange } = props;

    const [searchValue, setSearchValue] = useState(props.value ? ""+props.value : "");
    const [selected, setSelected] = useState(props.value);

    const [orgResults, setOrgResults] = useState([]);
    const [results, setResults] = useState([]);
    const [isFocussed, setIsFocussed] = useState(false);

    useEffect(() => {
        setOrgResults(options);
        setResults(options);
    },[options, orgResults])

    useEffect(() => {
        if(!orgResults || !props.visibleValue) return;
        setSearchValue(""+props.visibleValue);
    },[orgResults, props.visibleValue]);

    useEffect(() => {
        if(!orgResults) return;
        var filteredResults = orgResults.filter(result => result?.label?.toLowerCase().includes(searchValue.toLowerCase()));       
        setResults(filteredResults);
    },[searchValue, orgResults]);

    const setActive = (id, label) => {
        setSelected(id);
        setSearchValue(label);
        setIsFocussed(false);
        onChange(props.id, props.name, id);
    } 
    const focusHandler = () => {
        setSearchValue("");
        setSelected("");
        setIsFocussed(true)
    }

    const blurHandler = () => {
        setTimeout(function() {
            setIsFocussed(false);
        }, 250);
    }

    var visibleValue = options.filter(item => item.value===props.value).map(y => y.label)[0];

    return (
        <div className="flex flex-col relative" onBlur={blurHandler}>
            <input type="hidden" ref={ref} value={selected} name={props.name} />
            <Input value={visibleValue ? visibleValue : ""} xvalue={searchValue} readOnly={props.disabled} type="text" label={props.label} placeholder={props.placeholder} spellCheck="false" onChange={evt => setSearchValue(evt.target.value)} onFocus={focusHandler} />
            <div className={` ${(!isFocussed || props.disabled) && 'hidden'} bg-white w-full border-x rounded-b-xl border-slate-300 absolute top-full left-0 max-h-96 overflow-y-scroll z-20 shadow ${(isFocussed && results?.length>0) ? 'min-h-[100px]' : ''}`}>
                <div onClick={(id, label) => setActive("", "")} className="select-none flex flex-col gap-3 hover:bg-orange hover:text-white px-3 py-1 cursor-pointer border-b border-slate-100">
                    &shy;
                </div>
                {(results?.length>0) && results.map(result => { 
                    const randomKey = Math.floor(Math.random() * 9999999);
                    return (
                        <div data-key={"random"+randomKey} key={"random"+randomKey} onClick={(id, label) => setActive(result.value, result.label)} className={`${selected===result.value && 'bg-orange text-white'} select-none flex flex-col gap-3 hover:bg-orange hover:text-white px-3 py-1 cursor-pointer border-b border-slate-100`}>
                            {result.label}
                        </div>
                    )
                })}
            </div>
        </div>
    )
});

export default SmartSelector;